import React from "react";
import PropTypes from "prop-types";
import styles from "./index.css";

/**
 * for this page
 */

class Summary extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { content } = this.props;

        return (
            <div className={styles.summary}>
                <div>{content.title}</div>
            </div>
        );
    }
}

export default Summary;
